import React from 'react';
import Navbar from '../global/Navbar';
import Footer from '../global/Footer';
import PrivacyDetails from './PrivacyDetails';
import PageMeta from '../shared/PageMeta';



function Privacy() {
  return (
    <div>
      <PageMeta path="/privacy-policy" />
      <Navbar />
      <main id="main-content">
        <PrivacyDetails />
      </main>
      <Footer />
    </div>
  );
}

export default Privacy;
